import { render, staticRenderFns } from "./EditModelData.vue?vue&type=template&id=2a642c96&"
import script from "./EditModelData.vue?vue&type=script&lang=js&"
export * from "./EditModelData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports